import "../../foundations/colors.es.js";
import "../../foundations/shadows.es.js";
import { spacing as r } from "../../foundations/spacing.es.js";
import { a } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as i } from "@chakra-ui/react";
const { definePartsStyle: o, defineMultiStyleConfig: e } = i(
  a.keys
), d = o({
  icon: {
    boxSize: "size-150",
    color: "white"
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "full"
  },
  container: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "spacing-100",
    width: "fit-content"
  },
  controlContainer: {
    cursor: "pointer",
    transition: "background-color 150ms cubic-bezier(0.11, 0, 0.5, 0) 0s",
    padding: "spacing-100",
    m: `calc(${r["spacing-100"]} * -1)`,
    borderRadius: "full",
    _hover: {
      padding: "spacing-100",
      m: `calc(${r["spacing-100"]} * -1)`,
      borderRadius: "full",
      backgroundColor: "primary.50",
      width: "fit-content",
      "&:has([data-checked])": {
        backgroundColor: "secondary.50",
        width: "fit-content",
        padding: "spacing-100",
        m: `calc(${r["spacing-100"]} * -1)`,
        borderRadius: "full",
        _active: {
          backgroundColor: "secondary.100"
        }
      },
      "&:has([data-invalid])": {
        padding: "spacing-100",
        m: `calc(${r["spacing-100"]} * -1)`,
        borderRadius: "full",
        backgroundColor: "error.50",
        width: "fit-content"
      },
      "&:has([data-disabled])": {
        backgroundColor: "unset"
      }
    },
    "&:has([data-active])": {
      backgroundColor: "primary.100",
      "&:has([data-invalid])": {
        padding: "spacing-100",
        m: `calc(${r["spacing-100"]} * -1)`,
        borderRadius: "full",
        backgroundColor: "error.100",
        width: "fit-content",
        "&:has([data-checked])": {
          backgroundColor: "error.100"
        }
      }
    },
    "&:has(input:focus-visible)": {
      backgroundColor: "primary.50",
      width: "fit-content",
      padding: "spacing-100",
      m: `calc(${r["spacing-100"]} * -1)`,
      borderRadius: "full",
      "&:has([data-checked])": {
        backgroundColor: "secondary.50",
        width: "fit-content",
        padding: "spacing-100",
        m: `calc(${r["spacing-100"]} * -1)`,
        borderRadius: "full"
      },
      "&:has([data-invalid])": {
        padding: "spacing-100",
        m: `calc(${r["spacing-100"]} * -1)`,
        borderRadius: "full",
        backgroundColor: "error.50",
        width: "fit-content"
      }
    }
  },
  control: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSize: "size-200",
    border: "1px solid black",
    borderRadius: "5px",
    background: "white",
    _checked: {
      backgroundColor: "secondary.500",
      borderColor: "unset",
      borderWidth: 0,
      _disabled: {
        backgroundColor: "secondary.200",
        _checked: {
          borderColor: "unset",
          borderWidth: 0
        }
      },
      _invalid: {
        backgroundColor: "white"
      }
    },
    _active: {
      _checked: {
        backgroundColor: "secondary.700"
      },
      _invalid: {
        borderWidth: "1px",
        borderColor: "error.500",
        backgroundColor: "white"
      },
      _disabled: {
        backgroundColor: "unset",
        _checked: {
          backgroundColor: "secondary.200"
        }
      }
    },
    _disabled: {
      borderColor: "primary.200",
      borderWidth: "1px"
    },
    _invalid: {
      borderColor: "error.500",
      borderWidth: "1px"
    }
  },
  label: {
    fontSize: "md",
    lineHeight: "3.5",
    paddingX: "spacing-50",
    _disabled: {
      color: "primary.200"
    },
    "&[data-invalid]": {
      color: "error.500"
    }
  }
}), n = {
  default: {},
  right: o({
    container: {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      width: "100%"
    },
    label: {
      fontSize: "md"
    }
  })
}, g = e({
  baseStyle: d,
  variants: n
});
export {
  g as Checkbox
};
//# sourceMappingURL=Checkbox.es.js.map
